// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

import { BrowsePath, BrowsePathT, verifyBrowsePath } from "./browse-path";
import { ByteStringNodeId, ByteStringNodeIdT, verifyByteStringNodeId } from "./byte-string-node-id";
import { GuidNodeId, GuidNodeIdT, verifyGuidNodeId } from "./guid-node-id";
import {
  NodeIdentifier,
  unionToNodeIdentifier,
  unionListToNodeIdentifier,
} from "./node-identifier";
import { NumericNodeId, NumericNodeIdT, verifyNumericNodeId } from "./numeric-node-id";
import { StringNodeId, StringNodeIdT, verifyStringNodeId } from "./string-node-id";

/**
 * A fully qualified OPC UA NodeId (or browse-path reference to one).
 */
export class NodeId implements flatbuffers.IUnpackableObject<NodeIdT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): NodeId {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsNodeId(bb: flatbuffers.ByteBuffer, obj?: NodeId): NodeId {
    return (obj || new NodeId()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  static getSizePrefixedRootAsNodeId(bb: flatbuffers.ByteBuffer, obj?: NodeId): NodeId {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new NodeId()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  idType(): NodeIdentifier {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset ? this.bb!.readUint8(this.bb_pos + offset) : NodeIdentifier.NONE;
  }

  id<T extends flatbuffers.Table>(obj: any): any | null {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset ? this.bb!.__union(obj, this.bb_pos + offset) : null;
  }

  static startNodeId(builder: flatbuffers.Builder) {
    builder.startObject(2);
  }

  static addIdType(builder: flatbuffers.Builder, idType: NodeIdentifier) {
    builder.addFieldInt8(0, idType, NodeIdentifier.NONE);
  }

  static addId(builder: flatbuffers.Builder, idOffset: flatbuffers.Offset) {
    builder.addFieldOffset(1, idOffset, 0);
  }

  static endNodeId(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    builder.requiredField(offset, 6); // id
    return offset;
  }

  static createNodeId(
    builder: flatbuffers.Builder,
    idType: NodeIdentifier,
    idOffset: flatbuffers.Offset,
  ): flatbuffers.Offset {
    NodeId.startNodeId(builder);
    NodeId.addIdType(builder, idType);
    NodeId.addId(builder, idOffset);
    return NodeId.endNodeId(builder);
  }

  unpack(): NodeIdT {
    return new NodeIdT(
      this.idType(),
      (() => {
        const temp = unionToNodeIdentifier(this.idType(), this.id.bind(this));
        if (temp === null) {
          return null;
        }
        return temp.unpack();
      })(),
    );
  }

  unpackTo(_o: NodeIdT): void {
    _o.idType = this.idType();
    _o.id = (() => {
      const temp = unionToNodeIdentifier(this.idType(), this.id.bind(this));
      if (temp === null) {
        return null;
      }
      return temp.unpack();
    })();
  }

  unpackFields(...fields: string[]): NodeIdT {
    const t = new NodeIdT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("id_type")) {
      t.idType = this.idType();
    }
    if (fieldSet.has("id")) {
      t.id = (() => {
        const temp = unionToNodeIdentifier(this.idType(), this.id.bind(this));
        if (temp === null) {
          return null;
        }
        return temp.unpack();
      })();
    }
    return t;
  }
}

export class NodeIdT implements flatbuffers.IGeneratedObject {
  constructor(
    public idType: NodeIdentifier = NodeIdentifier.NONE,
    public id:
      BrowsePathT | ByteStringNodeIdT | GuidNodeIdT | NumericNodeIdT | StringNodeIdT | null = null,
  ) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    if (this.id === null || this.id === undefined) {
      throw new Error('Required field "id" is not set');
    }
    const id = builder.createObjectOffset(this.id);

    return NodeId.createNodeId(builder, this.idType, id);
  }

  clone(): NodeIdT {
    const obj = new NodeIdT();
    obj.idType = this.idType;
    obj.id =
      this.id !== null && typeof (this.id as any).clone === "function"
        ? (this.id as any).clone()
        : this.id;
    return obj;
  }

  equals(other: NodeIdT): boolean {
    if (this.idType !== other.idType) return false;
    if (this.id !== null && other.id !== null) {
      if (typeof (this.id as any).equals === "function") {
        if (!(this.id as any).equals(other.id)) return false;
      } else if (this.id !== other.id) return false;
    } else if (this.id !== other.id) return false;
    return true;
  }
}

export function verifyNodeId(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    verifier.checkScalarField(tablePos, 4, 1);
    verifier.checkUnionConsistency(tablePos, 4, 6, "id");
    {
      const pos = verifier.checkOffsetField(tablePos, 6);
      if (pos !== 0) {
        const uType = verifier.readFieldUint8(tablePos, 4);
        switch (uType) {
          case 1: // NumericNodeId
            {
              const o = verifier.readInt32(pos);
              verifyNumericNodeId(verifier, pos + o);
            }
            break;
          case 2: // StringNodeId
            {
              const o = verifier.readInt32(pos);
              verifyStringNodeId(verifier, pos + o);
            }
            break;
          case 3: // GuidNodeId
            {
              const o = verifier.readInt32(pos);
              verifyGuidNodeId(verifier, pos + o);
            }
            break;
          case 4: // ByteStringNodeId
            {
              const o = verifier.readInt32(pos);
              verifyByteStringNodeId(verifier, pos + o);
            }
            break;
          case 5: // BrowsePath
            {
              const o = verifier.readInt32(pos);
              verifyBrowsePath(verifier, pos + o);
            }
            break;
        }
      }
    }
    verifier.checkRequiredField(tablePos, 6, "id");
  } finally {
    verifier.popDepth();
  }
}
